const parseBooleanString = (value: string) => {
  if (!value) return null;
  if (value.toLocaleUpperCase() === "TRUE") return true;
  return false;
};

export default parseBooleanString;
